import { connect } from 'react-redux';
import { getAddress } from 'shared/account/reducer';
import SavedAddressForm from './SavedAddressForm';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var user = _ref.user;
  var match = _ref2.match;
  return {
    address: getAddress({
      user: user,
      match: match
    }),
    invoiceAddress: getAddress({
      user: user,
      match: match
    }).label === 'Invoice'
  };
};
export default connect(mapStateToProps)(SavedAddressForm);